import { GET_MAP_FEATURE_DETAILS } from '../actions/mapFeatureDetailsActions';

const initialState = {
    features: undefined,
    detailIsRefreshing: false
};

export function mapFeatures(state = initialState, action)
{
    switch (action.type)
    {
        case GET_MAP_FEATURE_DETAILS.pending:
        {
            return {
                ...state
                , features: undefined
                , detailIsRefreshing: true
            };
        }
        case GET_MAP_FEATURE_DETAILS.fulfilled:
        {
            return {
                ...state
                , features: action.payload
                , lastError: {}
                , detailIsRefreshing: false
            };
        }
        case GET_MAP_FEATURE_DETAILS.rejected:
        {
            return {
                ...state
                , features: undefined
                , lastError: action.payload
                , detailIsRefreshing: false
            };
        }
        default:
        {
            return state;
        }              
    }
}
